export default __webpack_public_path__ + "static/media/Carlos_Llerena.7b2934c9.jpg";